import { JumpToTab } from "../JumpToTab";

import { JSX } from "react";

import {
  AttributeComponentType,
  AttributeComponents,
  AttributeStrategy,
  ConfigurationComponentType,
  ConfigurationComponents,
  ControlComponents,
  ControlComponentsMapping,
  LayoutComponentProvider,
  LayoutControlType,
  OtherComponentType,
  OtherComponents,
} from "@plansoft-configuration-renderer/components";

import NavigationOutsideLayout from "./NavigationOutsideLayout";
import { CustomAttributeGroup } from "./components/CustomAttributeGroup/CustomAttributeGroup";
import { CustomCadClickCadBox } from "./components/CustomCadClickCadBox/CustomCadClickCadBox";
import { CustomSubconfigurationNavigation } from "./components/CustomSubconfigurationNavigation/CustomSubconfigurationNavigation";
import { CustomThumbnailControl } from "./components/CustomThumbnailControl/CustomThumbnailControl";
import { IndividualComponent } from "./components/Individual/IndividualComponent";
import { CustomUserDefinedFunctionButton } from "./components/Other/Button/CustomUserDefinedFunctionButton";
import { CustomAttributeHeadline } from "./controls/CustomAttributeHeadline";
import { CustomRadio } from "./controls/CustomRadio";
import { Select } from "./controls/CustomSelect/Select";
import { CustomTablesWrapper } from "./controls/CustomTable/CustomTablesWrapper";
import { CustomAttributePropertyText } from "./controls/CustomTable/custom/CustomAttributePropertyText";

// override control components for attributes
const controlComponents: ControlComponentsMapping = {
  ...ControlComponents, // the default components
  [LayoutControlType.Radios]: CustomRadio, // override radio control
  [LayoutControlType.Thumbnail]: CustomThumbnailControl,
  [LayoutControlType.Table]: CustomTablesWrapper,
  [LayoutControlType.Select]: Select,
};

// override configuration level components
const configurationComponents = {
  ...ConfigurationComponents,
  [ConfigurationComponentType.Individual]: IndividualComponent, // override individual control
  [ConfigurationComponentType.ConfigurationTree]: NavigationOutsideLayout,
  [ConfigurationComponentType.SubconfigurationNavigation]:
    CustomSubconfigurationNavigation,
  [ConfigurationComponentType.AttributeGroup]: CustomAttributeGroup,
};

// override attribute components
const attributeComponents = {
  ...AttributeComponents,
  [AttributeComponentType.AttributePropertyText]: CustomAttributePropertyText,
  [AttributeComponentType.AttributeHeadline]: CustomAttributeHeadline,
};

// override other components
const otherComponents = {
  ...OtherComponents,
  [OtherComponentType.CadClickCadBox]: CustomCadClickCadBox,
  [OtherComponentType.UserDefinedFunctionButton]:
    CustomUserDefinedFunctionButton,
};

export function CustomRenderer(): JSX.Element {
  // see properties of LayoutComponentProvider for more information
  return (
    <LayoutComponentProvider
      configurationComponents={configurationComponents}
      attributeComponents={attributeComponents}
      controlComponents={controlComponents}
      otherComponents={otherComponents}
    >
      {/* Attribute strategy renders the components using the layout information */}
      <AttributeStrategy />
      <JumpToTab />
    </LayoutComponentProvider>
  );
}
